import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#FFDA44\" d=\"M17.74 1.46A11.95 11.95 0 0 0 12.002 0C9.922 0 7.967.53 6.262 1.46L5.22 12l1.043 10.541c1.705.93 3.66 1.46 5.74 1.46 2.078 0 4.034-.53 5.739-1.46l1.043-10.54z\"></path><path fill=\"#338AF3\" d=\"M6.26 22.54V1.46A12 12 0 0 0 0 12c0 4.549 2.53 8.506 6.26 10.54\"></path><path fill=\"#6DA544\" d=\"M24 12c0-4.549-2.532-8.506-6.262-10.541v21.082A12 12 0 0 0 24 12M9.392 15.13 7.305 12l2.087-3.131 2.087 3.13zM14.61 15.13 12.523 12l2.087-3.131 2.087 3.13zM12.001 19.303l-2.087-3.13 2.087-3.13 2.087 3.13z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }